import angular from 'angular';
import ModalConfirmationSaveItemsComponent from './modal-confirmation-save-items.component';

let ModalConfirmationSaveItemsModule = angular.module('catalog.modalConfirmationSaveItems', [])
  .component('modalConfirmationSaveItems', ModalConfirmationSaveItemsComponent);

export default ModalConfirmationSaveItemsModule;













/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/catalog/modal-confirmation-save-items/modal-confirmation-save-items.js
 **/